module.exports = __webpack_public_path__ + "static/media/List-App-Mobile-X-6.1593d466.png";